import type { SubtaskDeepDiveItem } from 'redux/actions/tasks_v2'

export interface SubtaskWithUuid extends SubtaskDeepDiveItem {
  uuid: string
  disable_gallery_upload?: boolean
}

export const mediaName = (url: string) => {
  try {
    return decodeURIComponent(new URL(url, window.location.origin).pathname.split('/').pop() || '')
  } catch {
    return url.split('/').pop()?.split('?')[0] || ''
  }
}
export const videoMedia = (url: string) => /\.(mp4|mov|webm|m4v|avi|mkv)(?:[?#]|$)/i.test(url)
export const clampMediaIndex = (index: number, count: number) => Math.max(0, Math.min(index, count - 1))
